<template>
  <div class="flex items-center gap-1 overflow-y-scroll no-scrollbar -mx-[4vw] px-[4vw]">
    <div class="flex gap-4">
      <div class="button-group text-sm" v-auto-animate>
        <NuxtLink :class="{ 'active': !route.query?.tag }" :to="{ name: 'restaurants-city', params: { city: useSlugify(fat.city?.name) }}">
          {{ $t('shared.all') }}
        </NuxtLink>
        <!-- <NuxtLink :class="{ 'active': activeItem.active }" :to="{ name: 'restaurants-city', params: { city: activeItem.slug }}" v-if="activeItem">
          {{ activeItem.text }}
        </NuxtLink> -->
      </div>
      <div class="button-group text-sm" v-auto-animate>
        <button v-for="item in navItems.filter(item => item.groupId === 2)" @click="useUpdateQuery({ tag: item.slug })" :class="{ 'active': item.active }">
          {{ item.text }}
        </button>
        <!-- <NuxtLink :class="{ 'active': item.active }" :to="{ name: 'restaurants-city', params: { city: useSlugify(fat.city.name) }, query: { tag: item.slug }}" v-for="item in navItems.filter(item => item.groupId === 2)">
          {{ item.text }}
        </NuxtLink> -->
        <!-- <NuxtLink :class="{ 'active': item.active }" :to="{ name: 'restaurants-city-tag', params: { city: useSlugify(fat.city.name), tag: item.slug }}" v-for="item in navItems.filter(item => item.groupId === 2)">
          {{ item.text }}
        </NuxtLink> -->
      </div>
      <div class="button-group text-sm" v-auto-animate>
        <button v-for="item in navItems.filter(item => item.groupId === 7)" @click="useUpdateQuery({ tag: item.slug })" :class="{ 'active': item.active }">
          {{ item.text }}
        </button>
        <!-- <NuxtLink :class="{ 'active': item.active }" :to="{ name: 'restaurants-city', params: { city: useSlugify(fat.city.name) }, query: { tag: item.slug }}" v-for="item in navItems.filter(item => item.groupId === 7)">
          {{ item.text }}
        </NuxtLink> -->
        <!-- <NuxtLink :class="{ 'active': item.active }" :to="{ name: 'restaurants-city-tag', params: { city: useSlugify(fat.city.name), tag: item.slug }}" v-for="item in navItems.filter(item => item.groupId === 7)">
          {{ item.text }}
        </NuxtLink> -->
      </div>
    </div>
  </div>
</template>

<script async setup>
const route = useRoute()
const fat = useFatStore()

// const activeItem = computed(() => navItems.value?.find(item => item.active))

const navItems = computed(() => ([
  {
    id: 78,
    text: 'Italienskt',
    slug: 'italienskt',
    groupId: 2,
    active: route.query?.tag === 'italienskt'
  },
  {
    id: 87,
    text: 'Spanskt',
    slug: 'spanskt',
    groupId: 2,
    active: route.query?.tag === 'spanskt'
  },
  {
    id: 85,
    text: 'Franskt',
    slug: 'franskt',
    groupId: 2,
    active: route.query?.tag === 'franskt'
  },
  {
    id: 94,
    text: 'Uteservering',
    slug: 'uteservering',
    groupId: 7,
    active: route.query?.tag === 'uteservering'
  },
  {
    id: 103,
    text: 'Avsmakningsmeny',
    slug: 'avsmakningsmeny',
    groupId: 7,
    active: route.query?.tag === 'avsmakningsmeny'
  },
  {
    id: 97,
    text: 'Samtalsvänligt',
    slug: 'samtalsvanligt',
    groupId: 7,
    active: route.query?.tag === 'samtalsvanligt'
  }
]))
</script>